import React from "react";
import cmp from "../../assets/images/aboutus.png";
import "./Company.css";
import { FiLink } from "react-icons/fi";
import { colors } from "@mui/material";

function Company() {
  return (
    <div className="cmp-container">
      <div className="cmp-content">
        
        <div className="cmp-text">
          <div className="cmp-text-head">Our Company</div>
          <div className="cmp-text-desc">
            <p className="cmp-text-desc-upper">
              RisoApp is created by the same team that built RisoHire, a trusted
              career solutions platform serving companies and job seekers across
              India.
            </p>
            <p className="cmp-text-desc-upper">
              We are headquartered in Bengaluru, with a registered office in
              Berhampur, Odisha, and additional offices in Bhubaneswar, Delhi,
              and Mumbai — reflecting our pan-India presence.
            </p>
            <p className="cmp-text-desc-upper">
              Our leadership team combines extensive experience from leading
              education, technology, and HR organizations, all dedicated to
              transforming the way career guidance is delivered.
            </p>
            <p className="cmp-text-desc-upper">
              <FiLink className="cmp-text-desc-lower" />
              Discover more at{" "}
              
              <a
                href="https://risohire.com"
                target="_blank"
                rel="noopener noreferrer"
                className="cmp-text-desc-link"
              >
                <span style={{color:"blue"}}> https://risohire.com</span>
              </a>
            </p>
          </div>
        </div>
        <div className="cmp-img">
          <img src={cmp} alt="job" />
        </div>
      </div>
    </div>
  );
}

export default Company;